<div class="container">
  <div class="page-container">
    <div class="page-title">Manage Counties</div>
    <mat-divider class="divider-top"></mat-divider>
    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-programs">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Counties</div>
        <div class="pagination-select table-container">
          <mat-form-field>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          (click)="clearFilters()"
          [className]="
            this.getBaseQueryString() === this.getFullQueryString() ? 'clear-filter disabled-filter' : 'clear-filter'
          ">
          Clear All Filters
        </div>
      </div>
      <div class="right-section">
        <div class="add-new-program">
          <button color="primary" data-cy="newProgram" mat-raised-button (click)="updateRegridDates()">
            Update Regrid Dates
          </button>
        </div>
      </div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>

    <div class="table-container">
      <table [dataSource]="dataSource" aria-describedby="County List" mat-table>
        <ng-container matColumnDef="county">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div (click)="toggleSingleSort('county')" class="header-with-sort">
              <span>County Name</span>
              <span [class]="sortBy['county']" id="sort-icon-container">
                <fc-sort-icon [column]="'county'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
            <mat-form-field>
              <input
                #filterCounty
                (keyup)="applyFilter($event, 'county')"
                [(value)]="filterValues.county"
                matInput
                placeholder="Filter by County" />
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            {{ row.county }}
          </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div (click)="toggleSingleSort('state')" class="header-with-sort">
              <span>State</span>
              <span [class]="sortBy['state']" id="sort-icon-container">
                <fc-sort-icon [column]="'state'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
            <mat-form-field>
              <input
                #filterState
                (keyup)="applyFilter($event, 'state')"
                [(value)]="filterValues.state"
                matInput
                placeholder="Filter by State" />
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            {{ row.state }}
          </td>
        </ng-container>
        <ng-container matColumnDef="outDate">
          <th *matHeaderCellDef class="medium-column" mat-header-cell scope="col">
            <div>Up To Date</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="dropDownUpdate($event, 'up_to_date')"
                [(value)]="filterValues.up_to_date"
                class="select-filter"
                panelClass="is-active-panel"
                placeholder="">
                <mat-option [value]="">All</mat-option>
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            @if (row.upToDate) {
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Up To Date"></fa-icon>
            } @else {
              <fa-icon [icon]="['far', 'xmark']" class="red size-20" title="Out of Date"></fa-icon>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="available">
          <th *matHeaderCellDef class="medium-column" mat-header-cell scope="col">
            <div>Available</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="doApplyFilterSubject($event, 'available', 'eq')"
                [(value)]="filterValues.available"
                class="select-filter"
                panelClass="is-active-panel"
                placeholder="">
                <mat-option [value]="">All</mat-option>
                <mat-option [value]="false">No</mat-option>
                <mat-option [value]="true">Yes</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            @if (row.available) {
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Available"></fa-icon>
            } @else {
              <fa-icon [icon]="['far', 'xmark']" class="red size-20" title="Not Available"></fa-icon>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="regridRefresh">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div (click)="toggleSingleSort('regrid_refresh')" class="header-with-sort">
              <span>Regrid Update</span>
              <span [class]="sortBy['regrid_refresh']" id="sort-icon-container">
                <fc-sort-icon [column]="'regrid_refresh'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
          </th>
          <td *matCellDef="let row" class="small-column" mat-cell>
            {{ row.regridRefresh | date: 'shortDate' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastImport">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div (click)="toggleSingleSort('last_import')" class="header-with-sort">
              <span>Last Import</span>
              <span [class]="sortBy['last_import']" id="sort-icon-container">
                <fc-sort-icon [column]="'last_import'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
          </th>
          <td *matCellDef="let row" class="small-column" mat-cell>
            {{ row.lastImport | date: 'shortDate' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="regridFile">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div>
              <span>Regrid File Name</span>
            </div>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="program-link" data-cy="programLink">
              {{ row.regridFile }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div>
              <span>Import Status</span>
            </div>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="program-link" data-cy="programLink">
              {{ row.status }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="averageErt">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div>
              <span>Average ERT</span>
            </div>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="program-link" data-cy="programLink">
              {{ row.averageErt?.toFixed(4) }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell>Actions</th>
          <td *matCellDef="let row" mat-cell class="action-cell">
            <div (click)="editCounty(row)" class="open-icon">
              <fa-icon title="Edit County" [icon]="['fas', 'edit']" class="blue size-18"></fa-icon>
            </div>
            <div (click)="updateCounty(row)" class="open-icon">
              <fa-icon title="Update County" [icon]="['fas', 'rotate-left']" class="blue size-18"></fa-icon>
            </div>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
      <fc-spinner [overlay]="true" name="county-spinner" text="Loading Counties"></fc-spinner>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <fc-table-pagination
      [totalPages]="totalPages"
      (goToPage)="goToPage($event)"
      [currentPage]="currentPage"
      [showPages]="showPages"></fc-table-pagination>
  </div>
</div>
